module.exports = __webpack_public_path__ + "static/media/pasirris.c7ce0a6b.png";